import {
  PropsCategory,
  type PropertyPaneCategoryConfig,
} from "legacy/constants/PropertyControlConstants";
import { PanelCategory } from "legacy/pages/Editor/PropertyPane/propertyPaneCategoryUtils";
import { ANIMATE_LOADING_PROPERTY_CONTROL_HELP_TEXT } from "pages/Editors/AppBuilder/Sidebar/PropertyControlCommons";

import { sizeSection, visibleProperties } from "../basePropertySections";
import type { PDFViewerWidgetProps } from "./PDFViewerWidget";

const config: PropertyPaneCategoryConfig<PDFViewerWidgetProps>[] = [
  PanelCategory(PropsCategory.Content, [
    {
      propertyName: "fileUrl",
      helpText: "Set the URL/Base64 of the PDF file to display.",
      label: "HTTPS or Base64 URL",
      controlType: "INPUT_TEXT",
      placeholderText: "Enter URL / Base64",
      isBindProperty: true,
      isTriggerProperty: false,
    },
  ]),
  PanelCategory(PropsCategory.Appearance, [
    {
      helpText: ANIMATE_LOADING_PROPERTY_CONTROL_HELP_TEXT,
      propertyName: "animateLoading",
      label: "Loading animation",
      controlType: "SWITCH",
      isJSConvertible: true,
      isBindProperty: true,
      isTriggerProperty: false,
    },
  ]),
  PanelCategory(PropsCategory.Layout, [
    sizeSection(),
    ...visibleProperties({ useJsExpr: false }),
  ]),
];

export default config;
